import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";

class SiteCoreHelper {
  public static getTermsAndConditionsUrl(siteCoreAsset: ISitecoreAsset | undefined) {
    return siteCoreAsset && siteCoreAsset.dataUserTCLink || process.env.REACT_APP_PUBLIC_WEBSITE_URL + '/general-terms-conditions';
  }

  public static getTermsAndConditionsVersion(siteCoreAsset: ISitecoreAsset | undefined) {
    return siteCoreAsset && siteCoreAsset.dataUserTCVersionNumber || null;
  }
}

export default SiteCoreHelper;



// WEBPACK FOOTER //
// ./src/modules/core/helpers/SiteCoreHelper.tsx